/* eslint-disable react/style-prop-object */
import CurrencyCode from '@alltrails/shared/types/CurrencyCode';
import { FormattedMessage, FormattedNumber } from '@alltrails/shared/react-intl';
import PurchaseTier from 'types/PurchaseTier';
import Plan from 'types/Plan';

interface Params {
  currencyCode: CurrencyCode;
  plan: Plan;
  isMobileSizedScreen: boolean;
  isPromoEligible?: boolean;
}

const getPricingText = ({ plan, currencyCode, isPromoEligible, isMobileSizedScreen }: Params) => {
  if (isPromoEligible) {
    if (isMobileSizedScreen) {
      return (
        <FormattedMessage
          defaultMessage="7 days free, then {annualCost}/year"
          values={{ annualCost: <FormattedNumber currency={currencyCode} style="currency" value={plan.priceTotal} /> }}
        />
      );
    }

    return (
      <FormattedMessage
        defaultMessage="7 days free, then {annualCost}/year (that’s {monthlyCost}/month)"
        values={{
          annualCost: <FormattedNumber currency={currencyCode} style="currency" value={plan.priceTotal} />,
          monthlyCost: <FormattedNumber currency={currencyCode} style="currency" value={plan.priceMonth} />
        }}
      />
    );
  }

  return (
    <FormattedMessage
      defaultMessage="{annualCost}/year (that’s {monthlyCost}/month)"
      values={{
        annualCost: <FormattedNumber currency={currencyCode} style="currency" value={plan.priceTotal} />,
        monthlyCost: <FormattedNumber currency={currencyCode} style="currency" value={plan.priceMonth} />
      }}
    />
  );
};

export default getPricingText;
